import React from 'react'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const CallsListTab: React.FC = () => {
  const botId = useBotId()
  const location = useLocation()

  const callsListHref = `/bots/${botId}/calls`
  const isCallsListInHref = location.pathname.endsWith(callsListHref)

  return (
    <DisableableLink key="calls-list-tab" to={callsListHref}>
      <Tab size={18} label="Calls list" active={isCallsListInHref} />
    </DisableableLink>
  )
}
